module.exports = __webpack_public_path__ + "static/iwoca-account-manager-lisa-74fd5b49467d834483878b732b11fe5e.png";